import type { PicoAppEnum } from "jadro-pico/apps/PicoAppEnum";

// The access token is issued for pico-com whichever app the user is in, so the server cannot tell
// where a mutation came from. The request queue groups by it, so every mutation carries it.
let originApp: PicoAppEnum | undefined;

export function configureOriginApp(app: PicoAppEnum): void {
  originApp = app;
}

export function getOriginApp(): PicoAppEnum | undefined {
  return originApp;
}
